const guDigiLockerApaarModal = {
    "modal_title": "સાઇન અપ કરો",

    // Left Panel (DigiLocker)
    "left_panel_title": "પહેલેથી જ APAAR / ABC ID છે?",
    "left_panel_subtitle": "જો તમારી પાસે પહેલેથી જ APAAR / ABC ID હોય, તો DigiLocker નો ઉપયોગ કરીને નોંધણી કરવા માટે આ પગલાં અનુસરો:",
    "has_apaar_step1": "DigiLocker સાથે સાઇન અપ કરો પર ક્લિક કરો.",
    "has_apaar_step2": "તમારા આધાર સાથે લિંક કરેલા મોબાઇલ નંબરનો ઉપયોગ કરીને લોગિન કરો.",
    "has_apaar_step3": "તમારી APAAR વિગતો શેર કરવા માટે DigiLocker ને મંજૂરી આપો.",
    "has_apaar_step4": "નોંધણી પૂર્ણ કરવા માટે આપમેળે પાછા ફરો.",
    "btn_signup_digilocker": "DigiLocker સાથે સાઇન અપ કરો",

    // Right Panel (ABC Portal)
    "right_panel_title": "APAAR / ABC ID નથી?",
    "right_panel_subtitle": "જો તમારી પાસે APAAR / ABC ID ન હોય, તો નવો આઈડી બનાવવા માટે આ પગલાં અનુસરો:",
    "no_apaar_step1": "નીચે આપેલા Proceed to ABC Portal બટન પર ક્લિક કરો.",
    "no_apaar_step2": "તમારા આધાર સાથે લિંક કરેલા મોબાઇલ નંબરનો ઉપયોગ કરીને સાઇન ઇન કરો.",
    "no_apaar_step3": "ABC પોર્ટલ પર APAAR / ABC ID જનરેટ કરવાની પ્રક્રિયા પૂર્ણ કરો.",
    "no_apaar_step4": "તમારો APAAR / ABC ID જનરેટ થયા પછી આ પોર્ટલ પર પાછા આવો.",
    "no_apaar_step5": "તમારા DigiLocker સાથે ચાલુ રાખો",
    "btn_continue_abc": "ABC પોર્ટલ સાથે ચાલુ રાખો",

    // Bottom banner
    "bottom_info_banner": "તમારી માહિતી પ્રક્રિયા સુરક્ષિત રીતે કરવામાં આવે છે અને તેનો ઉપયોગ ફક્ત નોંધણી અને ઓળખ ચકાસણી માટે જ થાય છે."
};

export default guDigiLockerApaarModal;
